import { render, staticRenderFns } from "./book-tag.vue?vue&type=template&id=4688a2cc&scoped=true"
import script from "./book-tag.vue?vue&type=script&lang=js"
export * from "./book-tag.vue?vue&type=script&lang=js"
import style0 from "./book-tag.vue?vue&type=style&index=0&id=4688a2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688a2cc",
  null
  
)

export default component.exports